

// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const TextInput = ({ question, index, value, onChange, error, isSubmitted }) => {
//     const handleChange = (e) => {
//         let inputValue = e.target.value;
//         const validation = question.validation || {};

//         if (question.type === 'number') {
//             if (validation.pattern === 'numeric') {
//                 inputValue = inputValue.replace(/[^0-9]/g, '');
//             } else if (validation.allowDecimal) {
//                 const decimalPlaces = validation.decimalPlaces || 2;
//                 const regex = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`);

//                 if (inputValue && !regex.test(inputValue)) {
//                     return;
//                 }
//             } else {
//                 inputValue = inputValue.replace(/[^\d.]/g, '');
                
//                 const parts = inputValue.split('.');
//                 if (parts.length > 2) {
//                     inputValue = parts[0] + '.' + parts.slice(1).join('');
//                 }
//             }

//             if (validation.maxLength && inputValue) {
//                 const integerPart = inputValue.split('.')[0];
//                 if (integerPart.length > validation.maxLength) {
//                     return;
//                 }
//             }

//             if (inputValue === '' || inputValue === '.') {
//                 onChange(inputValue === '.' ? '' : inputValue);
//                 return;
//             }

//             if (inputValue && inputValue !== '-') {
//                 const numValue = parseFloat(inputValue);
                
//                 if (!isNaN(numValue)) {
//                     if (validation.max !== undefined && numValue > validation.max) {
//                         return;
//                     }
//                 }
//             }

//             onChange(inputValue);
//         } else if (question.type === 'text') {
//             if (validation.pattern === 'alphanumericDecimal') {
//                 const regex = /^[a-zA-Z0-9.]*$/;
//                 if (inputValue && !regex.test(inputValue)) {
//                     return;
//                 }
//             }
//             onChange(inputValue);
//         } else {
//             onChange(inputValue);
//         }
//     };

//     const handleKeyDown = (e) => {
//         if (question.type === 'number') {
//             const validation = question.validation || {};
//             const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
            
//             if (e.ctrlKey || e.metaKey) {
//                 return;
//             }
            
//             if (allowedKeys.includes(e.key)) {
//                 return;
//             }
            
//             if (validation.pattern === 'numeric') {
//                 const isNumber = /^[0-9]$/.test(e.key);
//                 if (!isNumber) {
//                     e.preventDefault();
//                 }
//             } else {
//                 const isNumber = /^[0-9]$/.test(e.key);
//                 const isDot = e.key === '.';
                
//                 if (isNumber) {
//                     return;
//                 }
                
//                 if (validation.allowDecimal && isDot && !value?.includes('.')) {
//                     return;
//                 }
                
//                 e.preventDefault();
//             }
//         }
//     };

//     const handleBlur = () => {
//         if (question.type === 'number' && value) {
//             const validation = question.validation || {};
//             const numValue = parseFloat(value);
            
//             if (!isNaN(numValue)) {
//                 if (validation.min !== undefined && numValue < validation.min) {
//                     onChange(String(validation.min));
//                 }
//             }
//         }
//     };

//     const getInputMode = () => {
//         if (question.type === 'number') {
//             if (question.validation?.allowDecimal) {
//                 return 'decimal';
//             }
//             return 'numeric';
//         }
//         return 'text';
//     };

//     const getPlaceholder = () => {
//         const validation = question.validation || {};

//         if (question.placeholder) {
//             return question.placeholder;
//         }

//         if (question.type === 'number') {
//             if (validation.min !== undefined && validation.max !== undefined) {
//                 return `Enter value (${validation.min}-${validation.max})`;
//             } else if (validation.min !== undefined) {
//                 return `Enter value (min ${validation.min})`;
//             } else if (validation.max !== undefined) {
//                 return `Enter value (max ${validation.max})`;
//             }
//         }

//         return 'Enter your answer';
//     };

//     const getHelperText = () => {
//         const validation = question.validation || {};
        
//         if (question.type === 'number' && validation.min !== undefined && validation.max !== undefined) {
//             return `Range: ${validation.min} - ${validation.max}`;
//         }
//         return null;
//     };

//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <span className={styles.questionNumber}>Q{index + 1}</span>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//             </div>
//             <div className={styles.inputWrapper}>
//                 <input
//                     type="text"
//                     value={value || ''}
//                     onChange={handleChange}
//                     onKeyDown={handleKeyDown}
//                     onBlur={handleBlur}
//                     placeholder={getPlaceholder()}
//                     disabled={isSubmitted}
//                     inputMode={getInputMode()}
//                     className={`${styles.input} ${error ? styles.inputError : ''} ${isSubmitted ? styles.disabled : ''}`}
//                 />
//                 {error && <ErrorMessage message={error} />}
//                 {!error && getHelperText() && (
//                     <div className={styles.helperText}>{getHelperText()}</div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default TextInput;

// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const TextInput = ({ question, index, value, onChange, error, isSubmitted }) => {
//     const handleChange = (e) => {
//         let inputValue = e.target.value;
//         const validation = question.validation || {};

//         if (question.type === 'number') {
//             if (validation.pattern === 'numeric') {
//                 inputValue = inputValue.replace(/[^0-9]/g, '');
//             } else if (validation.allowDecimal) {
//                 const decimalPlaces = validation.decimalPlaces || 2;
//                 const regex = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`);

//                 if (inputValue && !regex.test(inputValue)) {
//                     return;
//                 }
//             } else {
//                 inputValue = inputValue.replace(/[^\d.]/g, '');
                
//                 const parts = inputValue.split('.');
//                 if (parts.length > 2) {
//                     inputValue = parts[0] + '.' + parts.slice(1).join('');
//                 }
//             }

//             if (validation.maxLength && inputValue) {
//                 const integerPart = inputValue.split('.')[0];
//                 if (integerPart.length > validation.maxLength) {
//                     return;
//                 }
//             }

//             if (inputValue === '' || inputValue === '.') {
//                 onChange(inputValue === '.' ? '' : inputValue);
//                 return;
//             }

//             onChange(inputValue);
//         } else if (question.type === 'text') {
//             if (validation.pattern === 'alphanumericDecimal') {
//                 const regex = /^[0-9.]*$/;
//                 if (inputValue && !regex.test(inputValue)) {
//                     return;
//                 }
//             }
//             onChange(inputValue);
//         } else {
//             onChange(inputValue);
//         }
//     };

//     const handleKeyDown = (e) => {
//         if (question.type === 'number') {
//             const validation = question.validation || {};
//             const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
            
//             if (e.ctrlKey || e.metaKey) {
//                 return;
//             }
            
//             if (allowedKeys.includes(e.key)) {
//                 return;
//             }
            
//             if (validation.pattern === 'numeric') {
//                 const isNumber = /^[0-9]$/.test(e.key);
//                 if (!isNumber) {
//                     e.preventDefault();
//                 }
//             } else {
//                 const isNumber = /^[0-9]$/.test(e.key);
//                 const isDot = e.key === '.';
                
//                 if (isNumber) {
//                     return;
//                 }
                
//                 if (validation.allowDecimal && isDot && !value?.includes('.')) {
//                     return;
//                 }
                
//                 if (isDot && !value?.includes('.')) {
//                     return;
//                 }
                
//                 e.preventDefault();
//             }
//         }
//     };

//     const getInputMode = () => {
//         if (question.type === 'number') {
//             if (question.validation?.allowDecimal) {
//                 return 'decimal';
//             }
//             return 'numeric';
//         }
//         return 'text';
//     };

//     const getPlaceholder = () => {
//         if (question.placeholder) {
//             return question.placeholder;
//         }
//         return 'Enter your answer';
//     };

//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//             </div>
//             <div className={styles.inputWrapper}>
//                 <input
//                     type="text"
//                     value={value || ''}
//                     onChange={handleChange}
//                     onKeyDown={handleKeyDown}
//                     placeholder={getPlaceholder()}
//                     disabled={isSubmitted}
//                     inputMode={getInputMode()}
//                     className={`${styles.input} ${error ? styles.inputError : ''} ${isSubmitted ? styles.disabled : ''}`}
//                 />
//                 {error && <ErrorMessage message={error} />}
//             </div>
//         </div>
//     );
// };

// export default TextInput;
import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const TextInput = ({ question, index, value, onChange, error, isSubmitted, disabled = false, onBlur }) => {
    const handleChange = (e) => {
        let inputValue = e.target.value;
        const validation = question.validation || {};

        if (question.type === 'number') {
            if (validation.pattern === 'numeric') {
                inputValue = inputValue.replace(/[^0-9]/g, '');
            } else if (validation.allowDecimal) {
                const decimalPlaces = validation.decimalPlaces || 2;
                const regex = new RegExp(`^\\d*\\.?\\d{0,${decimalPlaces}}$`);

                if (inputValue && !regex.test(inputValue)) {
                    return;
                }
            } else {
                inputValue = inputValue.replace(/[^\d.]/g, '');
                
                const parts = inputValue.split('.');
                if (parts.length > 2) {
                    inputValue = parts[0] + '.' + parts.slice(1).join('');
                }
            }

            if (validation.maxLength && inputValue) {
                const integerPart = inputValue.split('.')[0];
                if (integerPart.length > validation.maxLength) {
                    return;
                }
            }

            if (inputValue === '' || inputValue === '.') {
                onChange(inputValue === '.' ? '' : inputValue);
                return;
            }

            onChange(inputValue);
        } else if (question.type === 'text') {
            if (validation.pattern === 'alphanumericDecimal') {
                const regex = /^[0-9.]*$/;
                if (inputValue && !regex.test(inputValue)) {
                    return;
                }
            }
            onChange(inputValue);
        } else {
            onChange(inputValue);
        }
    };

    const handleKeyDown = (e) => {
        if (question.type === 'number') {
            const validation = question.validation || {};
            const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
            
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            
            if (allowedKeys.includes(e.key)) {
                return;
            }
            
            if (validation.pattern === 'numeric') {
                const isNumber = /^[0-9]$/.test(e.key);
                if (!isNumber) {
                    e.preventDefault();
                }
            } else {
                const isNumber = /^[0-9]$/.test(e.key);
                const isDot = e.key === '.';
                
                if (isNumber) {
                    return;
                }
                
                if (validation.allowDecimal && isDot && !value?.includes('.')) {
                    return;
                }
                
                if (isDot && !value?.includes('.')) {
                    return;
                }
                
                e.preventDefault();
            }
        }
    };

    const getInputMode = () => {
        if (question.type === 'number') {
            if (question.validation?.allowDecimal) {
                return 'decimal';
            }
            return 'numeric';
        }
        return 'text';
    };

    const getPlaceholder = () => {
        if (question.placeholder) {
            return question.placeholder;
        }
        return 'Enter your answer';
    };

    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                </label>
            </div>
            <div className={styles.inputWrapper}>
                <input
                    type="text"
                    value={value || ''}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={onBlur}
                    placeholder={getPlaceholder()}
                    disabled={disabled}
                    inputMode={getInputMode()}
                    className={`${styles.input} ${error ? styles.inputError : ''} ${disabled ? styles.disabled : ''}`}
                />
                {error && <ErrorMessage message={error} />}
            </div>
        </div>
    );
};

export default TextInput;